var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"NetPaySuccess"},[_c('h4',{staticClass:"text-center cmsg"},[_vm._v("Estamos procesando su pago...")])])}]

export { render, staticRenderFns }